export default __webpack_public_path__ + "static/media/t1.0291b214.png";